module.exports = "/img/robot-btn.74215f19.gif";